document.addEventListener('DOMContentLoaded', function () {
    const addToCartForm = document.querySelector('[data-type="add-to-cart-form"]');
    const priceContainer = document.querySelector('.product__info-wrapper .price__container');
    const priceItemRegular = priceContainer.querySelector('.price__regular .price-item--regular');
    const priceItemSaleRegular = priceContainer.querySelector('.price__sale .price-item--regular');
    const priceItemSale = priceContainer.querySelector('.price__sale .price-item--sale');
    const defaultProdPrice= document.querySelector('.price__sale .price-item--sale')?.textContent?.trim();
    const bundleMediaGallery = document.querySelector('#kitty-kurlz-value-bundle-media-gallery');
    const bundleSelects = document.querySelectorAll('.product-form__submit.product-bundle-option');
    if (bundleSelects.length === 0) return;

    const mediaClickHandlers = new WeakMap();
    function stopItemClickEventPropagation(e) {
      e.stopImmediatePropagation(); // stops other handlers for this event
      e.preventDefault();           // optionally prevent default
    }

    function disableSliderMediaItemsClickOpenFunctionality() {
      const mediaItems = getSliderMediaItems();
      if (mediaItems.length === 0) return;
      mediaItems.forEach(function (mediaItem) {
        const list = mediaClickHandlers.get(mediaItem) || [];
        const tracked = list.some(entry => entry.type === "click" && entry.handler === stopItemClickEventPropagation);
        if (!tracked) {
          mediaItem.addEventListener('click', stopItemClickEventPropagation, true);
          if (!mediaClickHandlers.has(mediaItem)) mediaClickHandlers.set(mediaItem, []);
          mediaClickHandlers.get(mediaItem).push({ type: "click", handler: stopItemClickEventPropagation });
        }
      })
    }

    function getSliderMediaItems() {
      if (!bundleMediaGallery) {
        return false;
      }
      return bundleMediaGallery.querySelectorAll('.storista-feed-slider-item');
    }

    function getInputField(fieldName) {
        return addToCartForm.querySelector('input[name="'+fieldName+'"]');
    }

    function findVariantIdField() {
        let variantField = getInputField('id');
        if (!variantField) {
            variantField = addToCartForm.querySelector('select[name="id"]');
        }
        if (!variantField) {
            variantField = addToCartForm.querySelector('[name="id"]');
        }
        return variantField;
    }

    function updateProductPrice(bundlePrice, bundleComparePrice) {
        if (bundleComparePrice) {
            // If there's a compare price, show both
            priceItemSale.textContent = bundlePrice;
            priceItemSaleRegular.textContent = bundleComparePrice;
            priceItemSale.style.display = 'block';
            priceItemSaleRegular.style.display = 'block';
            return;
        }

        if (!bundleComparePrice && bundlePrice) {
            // If no compare price, just show regular price
            priceItemSale.textContent = bundlePrice;
            priceItemSale.style.display = 'block';
            return;
        }

        // If no sale price, just show regular price
        if (priceItemRegular) {
            priceItemRegular.textContent = defaultProdPrice;
        }
    }

    function resetSelectedVariant() {
        bundleSelects.forEach(function (bundleSelect) {
            bundleSelect.classList.remove('button--selected');
        });
    }

    function updateSelectedVariant(option) {
        const isCurrentlySelected = option?.classList?.contains('button--selected');
        if (isCurrentlySelected) return;

        // Reset all variants
        resetSelectedVariant();

        // Set the selected variant
        option.classList.add('button--selected');

        const productIdInput = getInputField('product-id');
        const variantIdInput = findVariantIdField();
        variantIdInput.value = option.dataset.variantId;
        productIdInput.value = option.dataset.productId;

        // Trigger the change event for the form
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        productIdInput.dispatchEvent(new Event('change', { bubbles: true }));

        updateProductPrice(option.dataset.bundleProductPrice, option.dataset.bundleComparePrice);

        // Show media gallery
        if (bundleMediaGallery) {
          if (bundleMediaGallery?.classList.contains('open')) {
            bundleMediaGallery?.classList.remove('open');
          }
          if (+option.dataset?.showMediaGallery) {
            bundleMediaGallery.classList.add('open');
            disableSliderMediaItemsClickOpenFunctionality()
          }
        }
    }

    bundleSelects.forEach(function (bundleItem, key) {
        if (key === 0) {
            // Set the first bundle as pre-selected
            updateSelectedVariant(bundleItem);
        }
        bundleItem.addEventListener('click', function (e) {
            updateSelectedVariant(this);
        });
    })
});
